exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Plannables-module__plannables-background___1FzvP{position:fixed;bottom:0;right:10px;height:60px;z-index:900}.Plannables-module__plannables-background___1FzvP .Plannables-module__front___3x8Sf{position:absolute;top:-8px;right:0;transition:top .5s}.Plannables-module__plannables-background___1FzvP .Plannables-module__gif___9qaCm{position:absolute;bottom:10px;right:0;width:250px}", ""]);

// exports
exports.locals = {
	"plannables-background": "Plannables-module__plannables-background___1FzvP",
	"front": "Plannables-module__front___3x8Sf",
	"gif": "Plannables-module__gif___9qaCm"
};